import React, {useState, useEffect, useContext} from "react";
import ModalContainer from "../../styles/Modals";
import useQuery from "../../hooks/useQuery";
import styled from "styled-components";
import Color from "../../assets/Colors";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {SelectedContainer, SelectStyled} from "../../styles/GlobalStyles";
import Select from "../../components/Select";
import {GlobalContext, sessionStarted} from "../../context/GlobalContext";
import {SubscribeCourse} from "../../services/GeneralServices";
import AppLoader from "../../components/loaders/Loader";

export default function SuscribeModal({url}) {
   const {userData, sessionStarted} = useContext(GlobalContext);
   const [hasCertified, setSertified] = useState("");
   const [isLoading, setLoading] = useState(false);
   const [ErrorFetch, setError] = useState(false);
   let query = useQuery();
   const isOpen = query.get("modal") === "true" ? true : false;
   let history = useHistory();
   let location = useLocation();
   let {id} = useParams();

   useEffect(() => {
      if (isOpen) {
         if (!sessionStarted) {
            history.replace("/iniciar_sesion", {prev: location.pathname + "" + location.search});
            // console.log();
         }
      } else {
         setError(false);
      }
   }, [isOpen]);

   function sendEmail(e) {
      e.preventDefault();
      setLoading(true);
      let toSend = {
         idUser: userData.idUser,
         idCourse: id,
      };
      /*  certified: e.target.certi.value === "otro" ? e.target.certifiedName.value : e.target.certi.value,
       position: e.target.position.value,
      
         */

      SubscribeCourse(toSend)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") {
               if (resp.message === "the user is already enrolled in the course") {
                  setError(true);
                  throw new Error();
               }
               throw new Error();
            }
            history.replace(history.location.pathname);
            window.open(url);
            setLoading(false);
         })
         .catch((e) => {
            console.log(e);
            setLoading(false);
         });
   }

   if (!isOpen) return null;
   return (
      <>
         <ModalContainer>
            <TitleModal>¡Gracias por tu interés!</TitleModal>
            <TextModal>Antes de iniciar con tu proceso de inscripción por favor completa el siguiente formulario</TextModal>
            <FormStyled onSubmit={sendEmail}>
               {/*  */}
               <LabelModal>¿Tienes alguna certificación? *</LabelModal>
               <Select
                  id="certi"
                  name="certi"
                  change={(e) => {
                     setSertified(e.target.value);
                  }}
                  options={[
                     {value: "Wine and Spirits Education Trust", name: "Wine and Spirits Education Trust"},
                     {value: "Court of Master Sommeliers", name: "Court of Master Sommeliers"},
                     {value: "Certified Specialist of Wine", name: "Certified Specialist of Wine"},
                     {value: "otro", name: "Otro"},
                  ]}
               />

               {hasCertified === "otro" && (
                  <>
                     <LabelModal>Especifica cual: *</LabelModal>
                     <InputStyled type="text" required name="certifiedName" />
                  </>
               )}

               {/*  */}
               <LabelModal>¿Dónde trabajas actualmente? *</LabelModal>
               <InputStyled type="text" name="job" required />
               {/*  */}
               <LabelModal>¿Qué cargo desempeñas actualmente? *</LabelModal>
               <Select
                  id="position"
                  name="position"
                  options={[
                     {value: 1, name: "Mesero"},
                     {value: 2, name: "Capitán"},
                     {value: 3, name: "Propietario"},
                     {value: 4, name: "Gerente"},
                     {value: 5, name: "Bartender"},
                     {value: 6, name: "Somelier"},
                  ]}
               />
               {ErrorFetch && <LabelModal color="crimson">Ya estás registrado a este curso</LabelModal>}
               <button className="buttonSend">ENVIAR</button>
            </FormStyled>
         </ModalContainer>
         <AppLoader isVisible={isLoading} />
      </>
   );
}

const TextModal = styled.p`
   color: ${(props) => props.color || "rgba(110,110,110,0.5)"};
   font-size: 0.8em;
   font-weight: 200;
   letter-spacing: 2px;

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
   }
`;

const TitleModal = styled(TextModal)`
   color: ${(props) => props.color || Color.primary};
   font-size: 1em;
   font-weight: 200;
   margin-bottom: 1.5em;
   line-height: 1.4em;

   @media screen and (max-width: 1600px) {
      font-size: 1em;
   }
`;

const LabelModal = styled(TextModal)`
   font-weight: bold;
   font-size: 0.8em;
   margin-top: 2em;
   margin-bottom: 0;
   color: ${(props) => props.color || "rgba(110, 110, 110, 0.9)"};
   letter-spacing: 1px;
`;

const InputStyled = styled.input`
   width: 100%;
   height: 100%;
   border: none;
   outline: none;
   border-bottom: 1px solid ${Color.textColor};
   color: ${(props) => props.color || Color.textColor};
   font-size: 1.4em;
   font-weight: 200;
   padding: 0.5em;
   margin-bottom: 1em;

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
   }
`;

const FormStyled = styled.form`
   margin-top: 2em;
   & .buttonSend {
      width: 80%;
      background: ${Color.primary};
      padding: 2em 0;
      color: white;
      margin: 0 auto;
      margin-top: 2em;
      border: none;
      outline: none;
      display: block;
      cursor: pointer;
   }
   @media screen and (max-width: 1600px) {
      & .buttonSend {
         padding: 1.5em 0;
      }
   }
`;
